<template>
  <div class="content">
    <div class="total">
      <div>
        <span class="title">饲草料采购数量(吨)：</span>
        <span class="value">{{infoObj?.forageCount||0}}</span>
      </div>
      <div>
        <span class="title">活畜月养殖平均用量(吨/月)：</span>
        <span class="value">{{infoObj?.aveForageCount||0}}</span>
      </div>
      <div>
        <span class="title">每只活畜平均月用量(吨/头/月)：</span>
        <span class="value">{{infoObj?.liveForageCount||0}}</span>
      </div>
    </div>
    <div class="card">
      <div class="card-item">
        <div class="icon-box">
          <img src="../../../../../assets/back/forage1.png" alt="" />
        </div>
        <div class="title-box">牧草</div>
        <div class="value-box">
          <span class="label">平均用量：</span>
          <span class="value">{{ infoObj?.grassUseDosage||0}}</span>
          <span class="label">吨/年</span>
        </div>
        <div class="value-box">
          <span class="label">现有储备：</span>
          <span class="value">{{ infoObj?.allgrassUseDosage||0}}</span>
        </div>
      </div>
      <div class="card-item">
        <div class="icon-box">
          <img src="../../../../../assets/back/forage2.png" alt="" />
        </div>
        <div class="title-box">饲料</div>
        <div class="value-box">
          <span class="label">平均用量：</span>
          <span class="value">{{ infoObj?.feedUse||0}}</span>
          <span class="label">吨/年</span>
        </div>
        <div class="value-box">
          <span class="label">现有储备：</span>
          <span class="value">{{ infoObj?.feedReserve||0}}</span>
          <span class="label">吨</span>
        </div>
      </div>
      <div class="card-item">
        <div class="icon-box">
          <img src="../../../../../assets/back/forage3.png" alt="" />
        </div>
        <div class="title-box">玉米</div>
        <div class="value-box">
          <span class="label">平均用量：</span>
          <span class="value">{{ infoObj?.maizeDosage||0}}</span>
          <span class="label">吨/年</span>
        </div>
        <div class="value-box">
          <span class="label">现有储备：</span>
          <span class="value">{{ infoObj?.maizeReserve||0}}</span>
          <span class="label">吨</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props:{
    loanYearQuery:{
        type:Object,
    }
  },
  data() {
    return {
        infoObj:{}
    }
  },

watch:{
    'loanYearQuery':{
        handler(){
            this.getInfo()
        },
        immediate:true,
        deep:true
    }
},

  methods: {
    getInfo(){
        this.$http({
            url: 'ffsapp-service/superviseProperty/queryForageStatistics',
			method: 'post',
            data:this.loanYearQuery
        }).then((res)=>{
            this.infoObj=res.data.result||{}
        })
    }
  },
}
</script>

<style scoped lang="scss">
.content {
  .total {
    width: 100%;
    height: 0.425rem;
    display: flex;
    font-size: 0.15rem;
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 400;
    color: #ffffff;
    align-items: center;
    margin-top: 0.3rem;
    div {
      margin-right: 0.95rem;
      display: flex;
      .title {
        font-size: 0.15rem;
        font-family: Source Han Sans, Source Han Sans;
        font-weight: 400;
        color: #ffffff;
      }
      .value {
        font-size: 0.25rem;
        font-family: DIN, DIN;
        font-weight: 700;
        color: #efab44;
      }
    }
  }
  .card {
    width: 100%;
    height: 3.125rem;
    margin-top: 0.4rem;
    display: flex;
    justify-content: space-between;
    &-item {
      width: 3.125rem;
      height: 100%;
      background: linear-gradient(154deg, rgba(255, 255, 255, 0.01) 0%, rgba(255, 255, 255, 0.06) 57%, rgba(255, 255, 255, 0.01) 100%);
      border-radius: 0.0125rem;
      padding-top: 0.25rem;
      box-sizing: border-box;
      .icon-box {
        width: 0.8rem;
        height: 0.75rem;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .title-box {
        width: 0.8rem;
        height: 0.25rem;
        margin: 0.22rem auto 0.36rem auto;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.175rem;
        font-family: Source Han Sans, Source Han Sans;
        font-weight: 700;
        color: #ffffff;
      }
      .value-box {
        width: 100%;
        height: 0.35rem;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        margin-bottom: 0.125rem;
        .label {
          display: flex;
          height: 0.25rem;
          font-size: 0.15rem;
          align-items: flex-end;
          font-family: Source Han Sans, Source Han Sans;
          font-weight: 400;
          color: #ffffff;
        }
        .value {
          display: flex;
          height: 0.25rem;
          align-items: flex-end;
          font-size: 0.25rem;
          font-family: DIN, DIN;
          font-weight: 700;
          color: #efab44;
          margin-right: 0.05rem;
        }
      }
    }
  }
}
</style>
